import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { Tab, Tabs } from '@rossum/ui/material';
import type { QueueSettingsPage } from '../fields/constants';
import { useVisibleQueueSettingsPages } from '../hooks/useVisibleQueueSettingsPages';

export const QueueSettingsTabs = ({
  value,
  parentPath,
}: {
  value: QueueSettingsPage;
  parentPath: string;
}) => {
  const intl = useIntl();
  const { push } = useHistory();
  const visiblePages = useVisibleQueueSettingsPages();

  return (
    <Tabs
      value={value}
      onChange={(_, newValue) => push(`${parentPath}/${newValue}`)}
    >
      {visiblePages
        // Because why the fuck not I guess
        .filter(p => p !== 'schema')
        .map(page => (
          <Tab
            key={page}
            label={intl.formatMessage({
              id: `containers.settings.queues.queue.${page}`,
            })}
            value={page}
            data-cy={`queue-settings-header-tab-${page}`}
            sx={{ minHeight: '48px' }}
            iconPosition="end"
          />
        ))}
    </Tabs>
  );
};
